export {
    default as TemplateLogin,
} from './login';
